<template>
    <v-form ref="form" v-model="valid">
        <!-- TODO [P4] workaround -->
        <v-text-field v-show="false" />
        <div class="d-flex align-center mb-2" :class="{'mb-8': !!point.address}">
            <div class="text-h6 text-capitalize me-2">
                {{ `${$t(`transfers.${pointType === 'departure' ? 'from' : 'to'}`)}: ` }}
            </div>
            <div class="d-flex align-center">
                <v-icon start>mdi-office-building</v-icon>
                <div class="text-subtitle-2">
                    <span v-html="formTitle" />
                    <div v-if="point.address" class="text-caption" style="position: absolute">
                        {{ point.address }}
                    </div>
                </div>
            </div>
        </div>
        <v-autocomplete
            v-if="!point.hotelCode && !isProductFieldDisabled('POINT_HOTEL_NAME')"
            v-model="hotelCode"
            :items="hotels"
            return-object
            item-title="hotelName"
            item-value="hotelCode"
            :disabled="disabled"
            :rules="hotelRules"
            :label="productFieldLabel('select_hotel', 'POINT_HOTEL_NAME')"
            clearable
        />
    </v-form>
</template>

<script lang="ts">
    import {Component, mixins, Prop, VModel} from 'vue-facing-decorator'
    import {TransferFormMixin} from '@/components/transfers/mixins/TransferFormMixin.vue'
    import {ProductBookingFieldsMixin} from '@/components/booking/mixins/ProductBookingFieldsMixin.vue'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    //TODO Need refactoring among other transfer forms
    @Component
    export class TransferHotelForm extends mixins(
        TransferFormMixin,
        FormValidationRulesMixin,
        ProductBookingFieldsMixin
    ) {
        @Prop({required: true}) pointType
        @Prop({default: () => []}) hotels
        @VModel({default: false}) valid
        @Prop({default: false, type: Boolean}) disabled
        @Prop({required: true}) product

        mounted() {
            if (this.point?.hotelCode) {
                this.setProp('hotelCode', this.point.hotelCode)
                this.setProp('hotelName', this.point.name)
            }
        }

        get hotelRules() {
            const rules = []
            if (this.isProductFieldMandatory('POINT_HOTEL_NAME') && !this.disableRequiredRule) {
                rules.push(this.requiredRule('select_hotel', 'POINT_HOTEL_NAME'))
            }
            return rules
        }

        get hotelCode() {
            if (!this.getProp('hotelCode')) {
                return null
            }

            return {
                hotelCode: this.getProp('hotelCode'),
                hotelName: this.getProp('hotelName'),
            }
        }

        set hotelCode(value) {
            if (value) {
                this.setProp('hotelCode', value.hotelCode)
                this.setProp('hotelName', value.hotelName)
            } else {
                this.setProp('hotelCode', null)
                this.setProp('hotelName', null)
            }
        }

        get ownProduct() {
            return transfersRuntimeStore.ownProduct(this.product)
        }
    }

    export default TransferHotelForm
</script>
